import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';

import PlanContent from '../molecules/PlanContent';
import Flight from '../molecules/Flight';
import AirlineTab from '../molecules/AirlineTab';
import LinkButton from '../atoms/button/LinkButton';
import ModalGoing from '../modal/ModalGoing';
import ModalBack from '../modal/ModalComingBack';
import NoResults from '../molecules/NoResults';

const flightSelector = (state) => state.flight;

const SearchFlightSP = ({ handleFlightSearch }) => {
  const {
    selectedOutboundFlight,
    selectedInboundFlight,
    searchedFlightsInput,
    fetchingOutbound,
    fetchingInbound,
    unavailableCarrierSelected,
  } = useSelector(flightSelector);

  const [ modalGoing, setModalGoing ] = useState(false);
  const [ modalBack, setModalBack ] = useState(false);

  const toggleModalGoing = useCallback(
    () => {
      setModalGoing(!modalGoing);
    },
    [ modalGoing ],
  );

  const toggleModalBack = useCallback(
    () => {
      setModalBack(!modalBack);
    },
    [ modalBack ],
  );

  const departureDate = searchedFlightsInput ?
    moment(searchedFlightsInput.outbound.date).format('YYYY年MM月DD日（ddd）') : '';
  const arrivalDate = searchedFlightsInput ?
    moment(searchedFlightsInput.inbound.date).format('YYYY年MM月DD日（ddd）') : '';

  const departureTitle = (
    <React.Fragment>
      行き <span style={{ marginLeft: 10 }}>{departureDate}</span>
    </React.Fragment>
  );
  const arrivalTitle = (
    <React.Fragment>
      帰り <span style={{ marginLeft: 10 }}>{arrivalDate}</span>
    </React.Fragment>
  );

  if ((!searchedFlightsInput || fetchingOutbound || fetchingInbound) && !unavailableCarrierSelected) {
    return null;
  }

  return (
    <React.Fragment>
      {!unavailableCarrierSelected && (
        <div style={{ marginBottom: 10 }}>
          <AirlineTab handleFlightSearch={handleFlightSearch} />
        </div>
      )}
      <div className="searchPlanContentsContainer">
        <div className="searchPlanContent">
          <div className="searchPlanContentItem">
            <PlanContent title={departureTitle}>
              <div className="searchPlanContentInner">
                {selectedOutboundFlight ? (
                  <React.Fragment>
                    <Flight seat={false} flight={selectedOutboundFlight} />
                    <div className="searchPlanContentInnerButton">
                      <LinkButton onClick={toggleModalGoing}>航空便を変更する</LinkButton>
                    </div>
                  </React.Fragment>
                ) : (
                  <NoResults
                    title="ご迷惑をおかけしております"
                    desc="該当の路線が無いか、アクセスが集中して繋がりにくくなっております。<br/>条件を変えていただくか、しばらくして再検索していただけますようお願い申し上げます。"
                  />
                )}
              </div>
            </PlanContent>
          </div>
          <div className="searchPlanContentItem">
            <PlanContent title={arrivalTitle}>
              <div className="searchPlanContentInner">
                {selectedInboundFlight ? (
                  <React.Fragment>
                    <Flight seat={false} flight={selectedInboundFlight} />
                    <div className="searchPlanContentInnerButton">
                      <LinkButton onClick={toggleModalBack}>航空便を変更する</LinkButton>
                    </div>
                  </React.Fragment>
                ) : (
                  <NoResults
                    title="ご迷惑をおかけしております"
                    desc="該当の路線が無いか、アクセスが集中して繋がりにくくなっております。<br/>条件を変えていただくか、しばらくして再検索していただけますようお願い申し上げます。"
                  />
                )}
              </div>
            </PlanContent>
          </div>
        </div>
      </div>
      <ModalGoing open={modalGoing} onClose={toggleModalGoing} hideSearchForm />
      <ModalBack open={modalBack} onClose={toggleModalBack} hideSearchForm />
    </React.Fragment>
  );

};

SearchFlightSP.propTypes = {
  handleFlightSearch: PropTypes.func.isRequired,
};

export default SearchFlightSP;